
import React from 'react';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Container from '@material-ui/core/Container';
import { MuiButton, MuiGrid, MuiTypography, MuiDivider, MuiInputBase, MuiFormControl, MuiInputLabel, MuiSelect, MuiMenuItem, MuiFormControlLabel, MuiSwitch, MuiFormLabel, MuiMoreVertIcon, muiWithStyles, MuiPopover, MuiKeyboardArrowUp, MuiKeyboardArrowDown, MuiCard } from '../../ui/MaterialUIComponents'
import { CssBaseline } from '@material-ui/core';
const useStyles = theme => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
    },
    li: {
      listStyle: 'none',
    },
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.grey[700] : theme.palette.grey[200],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
});
class PricingComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const classes = this.props.classes;
    return (

      <React.Fragment>
        <CssBaseline />
        {/* Hero unit */}
        <Container maxWidth="sm" component="main" className={classes.heroContent}>
          <MuiTypography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
            Pricing
      </MuiTypography>
          <MuiTypography variant="h5" align="center" color="textSecondary" component="p">
            Pricing is the process whereby a business sets the price at which it will sell its products and services, and may be part of the business's marketing plan.
      </MuiTypography>
        </Container>
        {/* End hero unit */}
        <Container maxWidth="md" component="main">
          <MuiGrid container spacing={5} alignItems="flex-end">
            {this.props.subscriptionPlans.map(plan => (
              // Enterprise card is full width at sm breakpoint
              <MuiGrid item key={plan.name} xs={12} sm={12} md={4}>
                <MuiCard>
                  <CardHeader
                    title={plan.name}
                    subheader={plan.subheader}
                    titleTypographyProps={{ align: 'center' }}
                    subheaderTypographyProps={{ align: 'center' }}
                    className={classes.cardHeader}
                  />
                  <CardContent>
                    <div className={classes.cardPricing}>
                      <MuiTypography component="h2" variant="h3" color="textPrimary">
                        ${plan.recurring_price.USD}
                      </MuiTypography>
                      <MuiTypography variant="h6" color="textSecondary">
                        /Year
                  </MuiTypography>
                    </div>
                    {/* <ul>
                      {plan.description.map(line => (
                        <MuiTypography component="li" variant="subtitle1" align="center" key={line}>
                          {line}
                        </MuiTypography>
                      ))}
                    </ul> */}
                  </CardContent>
                  <CardActions>
                    <MuiButton fullWidth  variant="contained" color="primary" onClick={(event)=>this.props.getSubscription(event,plan.id)}>
                     Subscribe
                    </MuiButton>
                  </CardActions>
                </MuiCard>
              </MuiGrid>
            ))}
          </MuiGrid>
        </Container>
      </React.Fragment>
    );

  }
}

export default muiWithStyles(useStyles)(PricingComponent);